import styled from '@emotion/styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background: #f6f7fb;
  border-radius: 16px;
  width: 900px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 24px 14px 24px;
  border-bottom: 1px solid #ccc;
`;

export const CenteredH2 = styled.h2`
  text-align: center;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 72px 108px;
`;

export const ModalField = styled.div`
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: 0.15px;
  }

  input {
    margin-top: 8px;
    height: 48px;
    width: 100%;
    border-radius: 8px;
    padding: 8px 12px;
    background: #ffffff;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #323f4b;
    border: 0;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin: 12px 24px 24px 24px;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 60px 0px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SuccessIconContainer = styled.div`
  height: 52px;
  width: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #158600;
  border-radius: 50%;
`;

export const SuccessMessageHeadline = styled.h2`
  text-align: center;
  color: #158600;
`;

export const SuccessMessageSubHeadline = styled.h2`
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.5px;
  text-align: center;
`;

export const ErrorIconContainer = styled.div`
  height: 52px;
  width: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #8d0909;
  border-radius: 50%;
`;

export const ErrorMessageHeadline = styled.h2`
  text-align: center;
  color: #8d0909;
`;

export const ErrorMessageSubHeadline = styled.h2`
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.5px;
  text-align: center;
`;
